export default __webpack_public_path__ + "static/1476-04393f9c9425adbaa5f6325fc946190b.gif";